import * as actionTypes from './actionTypes';
import axios from 'axios';
import { formatCurrency } from '../../shared/utility';


export const fetchProductsStart = (  ) => {
    return {
        type: actionTypes.FETCH_PRODUCTS_START,
    }
}
export const fetchProductsSuccess = ( productsData ) => {
    return {
        type: actionTypes.FETCH_PRODUCTS_SUCCESS,
        products: productsData
    }
}
export const fetchProductsFailed = ( errorMessage ) => {
    return {
        type: actionTypes.FETCH_PRODUCTS_FAILED,
        error: errorMessage,
    }
}
export const fetchProducts = (  ) => {
    return dispatch => {
        dispatch( fetchProductsStart( ) )
        axios.get('https://color-shop-c3776-default-rtdb.firebaseio.com/colors.json')
            .then( response => {
                let fetchedProducts = [ ];
                for ( let color in response.data ) {
                    let dollars =  formatCurrency(response.data[color].priceCents / 100) ;
                    let fetchedProduct= { id: color, price: dollars ,  ...response.data[color] }
                    fetchedProducts.push(fetchedProduct);
                }
                    dispatch( fetchProductsSuccess( fetchedProducts ) );
                })
                .catch( err => {
                    dispatch( fetchProductsFailed( err.message  ) )
                } )
            }
}


